import axios from 'axios'

async function getConfig() {
    const { data: config } = await axios.get('/store/config/web-config-distribution.json')
    sessionStorage.setItem('config', JSON.stringify(config))
}

getConfig()